module.exports = __webpack_public_path__ + "img/relief_5.23a90136.jpg";